import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'notification>items'
	},

	gql: {
		schema: gql`
			query NotificationItems(
			  $limit: [Int],
				$isread: Int
			) {
				request(
			    limit: $limit,
					isread: $isread
				) {
			    list {
						log_notification_id
			     	isread
			      subject
			      bodytext
			      created_dtm
			    }
			    pageInfo {
			      total_cnt
			      unread_cnt
			    }
				}
			}
		`
	}
};

export default request;
